module.exports = __webpack_public_path__ + "static/media/delivery-box.1f4b3d7d.svg";